<template>
  <el-checkbox-group
    class="up-checkbox"
    v-model="currentValue"
    v-bind="$attrs"
    @change="(value) => $emit('ny:check-box:change', value)"
    :size="size"
    :disabled="disabled"
  >
    <el-checkbox
      v-bind="$attrs"
      v-for="(item, index) in data"
      :key="item[keyValue[1]]"
      :label="item[keyValue[1]]"
    >{{item[keyValue[0]]}}</el-checkbox>
  </el-checkbox-group>
</template>

<script>
export default {
  name: 'UpCheckbox',
  props: {
    value: {},
    data: {
      type: Array,
      default: () => []
    },
    keyValue: {
      type: Array,
      default: () => ['name', 'value']
    },
    size: String,
    disabled: Boolean,
    component: {
      type: String,
      default: 'el-checkbox'
    }
  },
  data () {
    return {
      currentValue: this.value
    }
  },
  watch: {
    value (val) {
      this.currentValue = val
    },
    data (value) {
      console.log(value)
    },
    currentValue (val) {
      this.$emit('input', val)
      this.$emit('change', val)
    }
  }
}
</script>

<style lang="scss">
</style>
